import {Injectable} from '@angular/core';
import {Field} from '../../interfaces/Field';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Injectable()
export class FieldFormControlService {
  public toFormGroup(field?: Field) {
    if (field == null)
      field = <any>{};
    return new FormGroup({
      'name': new FormControl(field.name, Validators.required),
      'type': new FormControl(field.type, Validators.required),
      'readonly': new FormControl(field.readonly, Validators.required),
      'visible': new FormControl(field.visible, Validators.required),
      'signature': new FormControl(field.signature),
      'hint': new FormControl(field.hint),
      'required': new FormControl(field.required)
    });
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/services/field/field-form-control-service.ts